import React, { Component, useState, useEffect } from "react";
import { useGlobal } from "reactn";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import AdBoxWrapper from "components/Ads/AdBoxWrapper";
import AdComponent from "components/Ads/AdComponent";
import { useUserPremiumState } from "lib/hooks/userHooks";
import { MOBILE_SLIDE_GLOBAL_KEY } from "lib/constants";

function StickyGroup(props) {
  return (
    <div id="side-ads_sticky-group" className="side-ads_sticky-group">
      {props.children}
    </div>
  );
}

const SideAdsContainer = (props) => {
  const [init, setInit] = useState(false);
  const location = useLocation();
  const [windowBreakpoint] = useGlobal("responsive");
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  const [adblock] = useGlobal("adblock");
  const [isDetectingAdblock] = useGlobal("isDetectingAdblock");
  const { className, style } = props;
  const [mobileSlideClass] = useGlobal(MOBILE_SLIDE_GLOBAL_KEY);

  useEffect(() => {
    setInit(true);
  }, []);

  let dontShowSidesAds =
    !init ||
    loggingIn ||
    isDetectingAdblock ||
    adblock ||
    isPremium ||
    windowBreakpoint == "TABLET" ||
    windowBreakpoint == "MOBILE_LARGE" ||
    windowBreakpoint == "MOBILE_MEDIUM" ||
    windowBreakpoint == "MOBILE_SMALL";

  // console.log("dontShowSidesAds", {
  //   init,
  //   loggingIn,
  //   isDetectingAdblock,
  //   adblock,
  //   isPremium,
  //   windowBreakpoint,
  //   dontShowSidesAds
  // });

  if (dontShowSidesAds) {
    return null;
  }

  const sideAdsClassNames = classnames("side-ads-container", className);

  return (
    <div className={`${sideAdsClassNames} ${mobileSlideClass}`} style={style}>
      <StickyGroup>
        <AdBoxWrapper
          styles={{ paddingLeft: 12, paddingRight: 12, display: "flex", width: "auto" }}
          minAdWidth={324}
          minAdHeight={265}
        >
          <AdComponent
            slotId={"div-gpt-ad-ugg-1"}
            shouldChangeForRoute={(current, previous) => current.pathname !== previous.pathname}
          />
        </AdBoxWrapper>
        <AdBoxWrapper
          styles={{ paddingLeft: 12, paddingRight: 12, display: "flex", height: "auto" }}
          minAdWidth={324}
          minAdHeight={265}
        >
          <AdComponent
            slotId={"div-gpt-ad-ugg-3B"}
            shouldChangeForRoute={(current, previous) => current.pathname !== previous.pathname}
          />
          <div style={{ height: "1px", width: "1px" }}></div>
          <AdComponent
            slotId={"div-gpt-ad-ugg-3C"}
            shouldChangeForRoute={(current, previous) => current.pathname !== previous.pathname}
          />
        </AdBoxWrapper>
      </StickyGroup>
    </div>
  );
};

SideAdsContainer.defaultProps = {
  style: {},
  isSticky: true,
  topOffset: 0,
  bottomOffset: 0,
};

export default SideAdsContainer;
